
/**
 * Export `functions`.
 */

export const functions = {
  base: 'base',
  books: 'books',
  decors: 'decors',
  displays: 'displays',
  effects: 'effects',
  matching: 'matching',
  panels: 'panels',
  specialPieces: 'special pieces'
} as const;
